import { getElementSizes, subscribeToResize } from '@msc-b2c/shared-utils';

export const serviceCardLogic = (container: HTMLElement): void => {
  const accordionItem: HTMLElement | null = container.querySelector('.cmp-accordion__item');
  const imageContainer: HTMLElement | null = container.querySelector('.cmp-image');

  // Function to set max height based on image container width
  const setMaxHeight = () => {
    if (accordionItem && imageContainer) {
      const imageContainerWidth = getElementSizes(imageContainer).width;
      accordionItem.style.maxHeight = `${imageContainerWidth + 16}px`;
    }
  };

  // Initial call to set max height
  setMaxHeight();

  // Adjust max height on window resize
  const cleanup = subscribeToResize(() => {
    if (!container.isConnected) {
      cleanup();
      return;
    }
    setMaxHeight();
  });
};
